/**
 * Intercepta "Finalizar compra" / checkout nativo e manda para o Checkout LK.
 * Usar SOMENTE no tema duplicado até o go-live.
 */
(function () {
  var CHECKOUT_URL = window.LK_CHECKOUT_URL || 'https://checkout.lojaladykelly.com.br';
  var ATTRIBUTION = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'gclid', 'gbraid', 'wbraid', 'fbclid'];
  var STORE_KEY = 'lk_attribution';

  function readStored() {
    try {
      return JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}') || {};
    } catch (err) {
      return {};
    }
  }

  function rememberAttribution() {
    var current = readStored();
    var params = new URLSearchParams(window.location.search);
    ATTRIBUTION.forEach(function (key) {
      var value = params.get(key);
      if (value) current[key] = value;
    });
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify(current));
    } catch (err) {
      // sessão privada pode bloquear storage
    }
    return current;
  }

  function variantGid(numericId) {
    return 'gid://shopify/ProductVariant/' + numericId;
  }

  function goToCheckout(items) {
    if (!items || !items.length) {
      alert('Seu carrinho está vazio.');
      return;
    }
    var compact = items
      .map(function (item) {
        return item.variant_id + '|' + item.quantity;
      })
      .join(',');
    var url = new URL(CHECKOUT_URL + '/');
    url.searchParams.set('items', compact);
    if (/^[a-z0-9]{12,40}$/i.test(String(window.__lkFlowId || ''))) url.searchParams.set('lk_flow', window.__lkFlowId);
    var stored = rememberAttribution();
    ATTRIBUTION.forEach(function (key) {
      if (stored[key]) url.searchParams.set(key, stored[key]);
    });
    window.location.href = url.toString();
  }

  rememberAttribution();

  function fromCartJs() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        return (cart.items || []).map(function (item) {
          return { variant_id: item.variant_id, quantity: item.quantity };
        });
      });
  }

  function intercept(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest(
      '[name="checkout"], [name="goto_checkout"], button[type="submit"][name="checkout"], a[href="/checkout"], a[href*="/checkout"], .additional-checkout-buttons, shopify-accelerated-checkout, shopify-accelerated-checkout-cart'
    );

    var form = target.closest('form[action="/cart"]') || target.closest('form[action*="/cart"]');
    var isCheckoutSubmit =
      trigger ||
      (form && event.type === 'submit' && form.querySelector('[name="checkout"]'));

    if (!isCheckoutSubmit) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    fromCartJs()
      .then(goToCheckout)
      .catch(function () {
        alert('Não foi possível abrir o checkout. Tente de novo.');
      });
  }

  document.addEventListener('click', intercept, true);
  document.addEventListener('submit', intercept, true);
})();